import React from "react";
import styled from "styled-components";
import Floorplan from "../Specials/Floorplans/Components/Container.Floorplan";

const SelectedFloorplan = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${props => props.theme.themeColors[props.theme.activeTheme].selectedFloorplan};
  border-radius: 10px;
  margin-top: 24px;
  align-self: flex-end;
  
  @media screen and (min-width: ${(props) => props.theme.screenSizes.breakXsmall}) {
    padding: 10px 10px 0 10px;
  }
`;

function FloorplanMessage({ data }) {
  return (
    <SelectedFloorplan className="SelectedFloorPlan">
      <Floorplan data={data} banner={"none"} selected/>
    </SelectedFloorplan>
  );
}

export default FloorplanMessage;
